
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://faxzuquiffsmwchtqzwl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZheHp1cXVpZmZzbXdjaHRxendsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU0NDI0MDIsImV4cCI6MjA2MTAxODQwMn0.-Q1H-hjfDOJwUJ1D5wZTPQhkzioUppNn-i2j6RAlvWk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Create a client with custom types for our tables
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
